<template>
  <div>
        
        <blog-story-line />

        <blog-accordion />

        <blog-latest />

        <blog-saved />

        <blog-articles />

        <how-help />

        <Else />

        <share-social-modal />
        
  </div>
</template>


<script>
import BlogStoryLine from './StoryLine'
import BlogAccordion from './BlogAccordion'
import BlogLatest from './BlogLatest'
import BlogSaved from './BlogSaved'
import BlogArticles from './BlogArticles'
import HowHelp from '../HowHelp'
import Else from '../Else'
import ShareSocialModal from './ShareSocialModal'

export default {
    name: "BlogPage",
    components: {
        BlogStoryLine, BlogAccordion, BlogLatest, BlogSaved, BlogArticles, HowHelp,
        Else, ShareSocialModal

    }
}
</script>

<style>

</style>